import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, SHAPES } from '../gameData';

export default class GreenhouseArea extends RegionArea
{
    /**
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[parentRegion.region].GREENHOUSE);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.fullGreenhouse.setAlpha(0);
        this.greenhouseFront.setAlpha(0);
        this.bottomPlantBox.setAlpha(0);
        this.middlePlantBox.setAlpha(0);
        this.topPlantBox.setAlpha(0);
        this.plantContainer0.setAlpha(0);
        this.plantContainer1.setAlpha(0);
        this.plantContainer2.setAlpha(0);
        this.plantContainer3.setAlpha(0);
        this.plantContainer4.setAlpha(0);
        this.plantContainer5.setAlpha(0);
        this.plantContainer6.setAlpha(0);
        this.plantContainer7.setAlpha(0);
        this.plantContainer8.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.fullGreenhouse.disableInteractive();
        this.greenhouseFront.disableInteractive();
        this.bottomPlantBox.disableInteractive();
        this.middlePlantBox.disableInteractive();
        this.topPlantBox.disableInteractive();
        this.plantContainer0.disableInteractive();
        this.plantContainer1.disableInteractive();
        this.plantContainer2.disableInteractive();
        this.plantContainer3.disableInteractive();
        this.plantContainer4.disableInteractive();
        this.plantContainer5.disableInteractive();
        this.plantContainer6.disableInteractive();
        this.plantContainer7.disableInteractive();
        this.plantContainer8.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.fullGreenhouse.setAlpha(0.000001);
        this.greenhouseFront.setAlpha(0.000001);
        this.bottomPlantBox.setAlpha(0.000001);
        this.middlePlantBox.setAlpha(0.000001);
        this.topPlantBox.setAlpha(0.000001);
        this.plantContainer0.setAlpha(0.000001);
        this.plantContainer1.setAlpha(0.000001);
        this.plantContainer2.setAlpha(0.000001);
        this.plantContainer3.setAlpha(0.000001);
        this.plantContainer4.setAlpha(0.000001);
        this.plantContainer5.setAlpha(0.000001);
        this.plantContainer6.setAlpha(0.000001);
        this.plantContainer7.setAlpha(0.000001);
        this.plantContainer8.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        let fullGreenhouseHitArea = new Phaser.Geom.Polygon(
            [
                { x: 313, y: 503 },
                { x: 0, y: 319 },
                { x: 156, y: 183 },
                { x: 474, y: 0 },
                { x: 633, y: 317 },
            ]);
        this.fullGreenhouse = ABCya.Images.addImage(670, 379, UIAssetKeys._12_Space_Zoom_In_Greenhouse_Slct_Grnhous, this.parentRegion).setInteractive(fullGreenhouseHitArea, Phaser.Geom.Polygon.Contains);
        this.fullGreenhouse.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.fullGreenhouse, SHAPES.TRIANGULAR_PRISM);
        });

        let greenhouseFrontHitArea = new Phaser.Geom.Polygon(
            [
                { x: 316, y: 317 },
                { x: 0, y: 135 },
                { x: 155, y: 0 },
            ]);
        this.greenhouseFront = ABCya.Images.addImage(511, 470, UIAssetKeys._12_Space_Zoom_In_Greenhouse_Slct_GrnhousFrnt, this.parentRegion).setInteractive(greenhouseFrontHitArea, Phaser.Geom.Polygon.Contains);
        this.greenhouseFront.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.greenhouseFront, SHAPES.TRIANGLE);
        });

        let plantContainerHitArea = new Phaser.Geom.Polygon(
            [
                { x: 19, y: 49 },
                { x: 0, y: 39 },
                { x: 0, y: 9 },
                { x: 19, y: 0 },
                { x: 38, y: 9 },
                { x: 38, y: 39 },
            ]);
        for (let i = 0; i < 9; i++)
        {
            this["plantContainer" + i] = ABCya.Images.addImage(0, 0, UIAssetKeys._12_Space_Zoom_In_Greenhouse_Slct_Plnt1, this.parentRegion).setInteractive(plantContainerHitArea, Phaser.Geom.Polygon.Contains);
            this["plantContainer" + i].on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => 
            {
                this._onOverlayPointerDown(this["plantContainer" + i], SHAPES.CYLINDER);
            });
        }
        this.plantContainer0.setPosition(445, 464);
        this.plantContainer1.setPosition(481, 444);
        this.plantContainer2.setPosition(516, 425);
        this.plantContainer3.setPosition(550, 403);
        this.plantContainer4.setPosition(587, 385);
        this.plantContainer5.setPosition(623, 362);
        this.plantContainer6.setPosition(656, 343);
        this.plantContainer7.setPosition(692, 322);
        this.plantContainer8.setPosition(727, 305);

        let plantBoxHitArea = new Phaser.Geom.Polygon(
            [
                { x: 90, y: 105 },
                { x: 0, y: 52 },
                { x: 90, y: 0 },
                { x: 179, y: 52 },
            ]);
        this.bottomPlantBox = ABCya.Images.addImage(663, 550, UIAssetKeys._12_Space_Zoom_In_Greenhouse_Slct_PlntBx, this.parentRegion).setInteractive(plantBoxHitArea, Phaser.Geom.Polygon.Contains);
        this.bottomPlantBox.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.bottomPlantBox, SHAPES.SQUARE);
        });

        this.middlePlantBox = ABCya.Images.addImage(770, 489, UIAssetKeys._12_Space_Zoom_In_Greenhouse_Slct_PlntBx, this.parentRegion).setInteractive(plantBoxHitArea, Phaser.Geom.Polygon.Contains);
        this.middlePlantBox.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.middlePlantBox, SHAPES.SQUARE);
        });

        this.topPlantBox = ABCya.Images.addImage(872, 430, UIAssetKeys._12_Space_Zoom_In_Greenhouse_Slct_PlntBx, this.parentRegion).setInteractive(plantBoxHitArea, Phaser.Geom.Polygon.Contains);
        this.topPlantBox.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.topPlantBox, SHAPES.SQUARE);
        });

        this.shapeOverlays[SHAPES.SQUARE] = [this.bottomPlantBox, this.middlePlantBox, this.topPlantBox];
        this.shapeOverlays[SHAPES.TRIANGLE] = [this.greenhouseFront];
        this.shapeOverlays[SHAPES.CYLINDER] =
            [
                this.plantContainer0, this.plantContainer1, this.plantContainer2, this.plantContainer3,
                this.plantContainer4, this.plantContainer5, this.plantContainer6, this.plantContainer7, this.plantContainer8
            ];
        this.shapeOverlays[SHAPES.TRIANGULAR_PRISM] = [this.fullGreenhouse];

        this._createAreaInformation(0x5f5fd6, 0x67adb9);
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.roverContainer, this.parentRegion.dome
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.greenhouse, duration: 1000, props: { scale: 1, x: 669, y: 381 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.fullGreenhouse.disableInteractive();
        this.greenhouseFront.disableInteractive();
        this.bottomPlantBox.disableInteractive();
        this.middlePlantBox.disableInteractive();
        this.topPlantBox.disableInteractive();
        this.plantContainer0.disableInteractive();
        this.plantContainer1.disableInteractive();
        this.plantContainer2.disableInteractive();
        this.plantContainer3.disableInteractive();
        this.plantContainer4.disableInteractive();
        this.plantContainer5.disableInteractive();
        this.plantContainer6.disableInteractive();
        this.plantContainer7.disableInteractive();
        this.plantContainer8.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.greenhouse, duration: 1000, props: { scale: 0.5156, x: this.parentRegion.greenhouse.onScreenPosition.x, y: this.parentRegion.greenhouse.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.roverContainer, this.parentRegion.dome], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}